import { FileText, Video, Bot, Link } from "lucide-react";
import { formatDate } from "../../lib/utils";
import VideoPopup from "./video_popup.jsx";
import React from 'react';

export const sourceConfigs = {
  lectures: {
    icon: <Video className="flex-shrink-0 text-green-400" />,
    make_title: (result) => `${result.lecture_name}`,
    make_metadata: (result) => `${result.host_name} • ${formatDate(result.upload_date, {useAlphabetDate: true})} • Starting from: ${result.timestamp_start}`,
    make_text: (result) => result.content,
    make_link_component: (data, header) => (
        <VideoPopup panoptoURL={data.remote_url} title={sourceConfigs.lectures.make_title(data)} className="block">
            <div className="relative p-2 hover:bg-accent transition-colors duration-200">
                {header}
            </div>
        </VideoPopup>
    ),
    label: "Lecture",
  },
  moodle: {
    icon: <FileText className="flex-shrink-0 text-blue-400" />,
    make_title: (result) => `${result?.file_name}.pdf`,
    make_metadata: (result) => `${formatDate(result?.upload_date, {useAlphabetDate: true})} • Page ${result?.page}/${result?.total_pages} `,
    make_text: (result) => result?.content,
    make_link_component: (data, header) => (
        <a
            href={data.remote_url}
            target="_blank"
            rel="noopener noreferrer"
            className="relative block p-2 hover:bg-accent transition-colors duration-200"
        >
            {header}
        </a>
    ),
    label: "Document",
  },
  not_from_context: {
    icon: <Bot className="flex-shrink-0 text-purple-400" />,
    make_title: () => "*Chat's General Knowledge* ",
    make_metadata: () => "Not from course materials. It is recommended to verify this statement.",
    make_text: (result) => `${sourceConfigs.not_from_context.make_title(result)}. ${sourceConfigs.not_from_context.make_metadata(result)}`,
    trigger_icon: <Bot className="w-4 h-4" />,
    label: "Chat",
    make_link_component: () => null
  },
};